const Routers = {
  All: "/*",
  Dashboard: "/",
  Login: "/login",
  ChangePassword: "/change-password",
  ForgotPassword: "/forgot-password",
  ResetPassword: "/reset-password",
  SmsVerification: "/v/:token",

  // Variable Cost Register
  VariableCostRegister: "/variable-cost-register",

  // Application Create
  ApplicationCreate: "/application-create",
  ApplicationReview: "/application-review",
  BrokerAccess: "/broker-access",

  // Contracts
  ContractsList: "/contracts-list",
  ContractsDetail: "/contracts-detail",
  GuaraUpdateConfirm: "/guara-update-confirm",

  // Notice
  Notice: "/notice",

  // Receipt Invoice
  ReceiptInvoice: "/receipt-invoice",

  // Subrogation Payment
  SubrogationPayment: "/subrogation-payment",

  // Inclusive Contract
  InclusiveContractApplication: "/inclusive-contracts",
  InclusiveContractDetail: "/inclusive-contract-detail",
  InclusiveContractCreate: "/inclusive-contract-create",

  // Received Invoice
  ReceivedInvoice: "/received-invoice",

  // Cancellation Register
  CancellationRegister: "/cancellation-register",

  // Error Pages
  BadRequest: "/400",
  Forbidden: "/403",
  NotFound: "/not-found",

  // Health Check
  HealthCheck: "/healthcheck-fe",

  // Maintenance
  Maintenance: "/maintenance",

  // Initial Guarantee Fee
  InitialGuaranteeFee: "/initial-guarantee-fee",

  // Settings
  Settings: "/settings",
  ShopRegistrationApplies: "/shop-registration-applies",
  BrokerProfileSetup: "/broker-profile-setup"
};

export default Routers;
